// 사용자 UI 환경설정(설정 시트) — 글자 크기 + 앱 내 모션 최소화 적용.
// 소리·모션 '값'은 각각 world/sound.ts·lib/fxPref.ts 가 소유. 여기선 그 값을 **화면에 반영**하는 일과
// 글자 크기(신규)를 담당한다. 부팅 시 initUiPrefs() 1회 호출로 저장값을 복원한다.
import { reduceMotionWanted } from "./fxPref";

const SCALE_KEY = "gc_text_scale";
// 0=보통, 1=크게, 2=더 크게 → 루트 글자 크기(rem 기준 스케일). 영유아·보호자 가독성.
const SCALE_PCT = [100, 112, 125] as const;
export type TextScale = 0 | 1 | 2;

export function getTextScale(): TextScale {
  try {
    const n = Number(localStorage.getItem(SCALE_KEY));
    if (n === 1 || n === 2) return n;
  } catch {
    /* 무시 */
  }
  return 0;
}

export function setTextScale(v: TextScale): void {
  try {
    localStorage.setItem(SCALE_KEY, String(v));
  } catch {
    /* 무시 */
  }
  applyTextScale();
}

/** 저장된 글자 크기를 루트(html)에 반영. rem 기반 텍스트가 함께 커진다. */
export function applyTextScale(): void {
  if (typeof document === "undefined") return;
  document.documentElement.style.fontSize = `${SCALE_PCT[getTextScale()]}%`;
}

/** 앱 내 '모션 최소화'(fxPref 값)를 CSS에도 반영 — 루트 data 속성. OS prefers-reduced-motion 과 별개로
 *  사용자가 앱에서 켠 경우에도 CSS 애니메이션이 멈추도록(styles.css 의 [data-reduce-motion] 규칙). */
export function applyReduceMotion(): void {
  if (typeof document === "undefined") return;
  // 🔴 getFxLow() 가 아니다 — 그건 기기 성능까지 봐서 폰 대부분을 「줄이기」로 만들었다(마법이 안 움직인 원인)
  if (reduceMotionWanted()) document.documentElement.setAttribute("data-reduce-motion", "1");
  else document.documentElement.removeAttribute("data-reduce-motion");
}

/** 부팅 1회 — 저장된 UI 환경설정을 화면에 복원. */
export function initUiPrefs(): void {
  applyTextScale();
  applyReduceMotion();
}
